import SingleAd from "./SingleAd";

export default SingleAd